const initialState = { severity: '', content: '', show: false };

const alert = (state = initialState, action) => {
    switch (action.type) {
        case 'ALERT_SUCCESS': {
            return { severity: 'success', content: action.payload, show: true };
        }

        case 'ALERT_ERROR': {
            return { severity: 'error', content: action.payload, show: true };
        }

        case 'ALERT_NOTIFICATION': {
            return {
                severity: 'info',
                content: action.payload,
                show: true,
            };
        }

        case 'ALERT_RESET': {
            return { ...state, content: '', show: false };
        }

        default: {
            return state;
        }
    }
};

export default alert;
